import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export const LanguageSwitcher = ({ className = '', testId = 'language-switcher' }) => {
  const { lang, setLang, supportedLanguages } = useLanguage();

  return (
    <div
      data-testid={testId}
      className={`inline-flex items-center gap-2 ${className}`}
    >
      {supportedLanguages.map((code, i) => (
        <React.Fragment key={code}>
          <button
            onClick={() => setLang(code)}
            data-testid={`lang-${code}`}
            aria-label={`Switch to ${code.toUpperCase()}`}
            aria-current={lang === code ? 'true' : 'false'}
            className={`eyebrow transition-colors duration-300 ${
              lang === code
                ? 'text-lilac'
                : 'text-neutral-400 hover:text-neutral-100'
            }`}
          >
            {code.toUpperCase()}
          </button>
          {i < supportedLanguages.length - 1 && (
            <span className="text-neutral-600 select-none" aria-hidden="true">·</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
